"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * This module exports the native `fetch` function if available
 * (e.g. in the browser or in React Native), and exports the
 * `node-fetch` module if not.
*/
var getFetch = function getFetch() {
  if (typeof fetch !== 'undefined') {
    return fetch; // eslint-disable-line no-undef
  }

  return require('node-fetch'); // eslint-disable-line global-require
};

var _default = getFetch();

exports["default"] = _default;